import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { adminLogout, getStoredAdmin } from "@/lib/auth";
import { Wordmark } from "@/components/ui/Wordmark";
import {
  IconCal,
  IconDashboard,
  IconForm,
  IconLogout,
  IconSettings,
  IconUsers,
} from "@/components/admin/Icons";

const ITEMS = [
  { to: "/admin/dashboard", label: "Dashboard", Icon: IconDashboard },
  { to: "/admin/leads", label: "Leads", Icon: IconUsers },
  { to: "/admin/agenda", label: "Agenda", Icon: IconCal },
  { to: "/admin/formulario", label: "Formulario", Icon: IconForm },
  { to: "/admin/palestras", label: "Palestras", Icon: IconForm },
  { to: "/admin/settings", label: "Configurações", Icon: IconSettings },
];

export default function AdminLayout() {
  const navigate = useNavigate();
  const admin = getStoredAdmin();

  const handleLogout = () => {
    adminLogout();
    navigate("/admin/login", { replace: true });
  };

  return (
    <div className="adm-app">
      <aside className="adm-side">
        <div className="adm-side-brand">
          <Wordmark onClick={() => navigate("/admin/dashboard")} />
        </div>
        <nav className="adm-nav">
          {ITEMS.map(({ to, label, Icon }) => (
            <NavLink
              key={to}
              to={to}
              end={to === "/admin/dashboard"}
              className={({ isActive }) => `adm-nav-link ${isActive ? "active" : ""}`}
            >
              <Icon />
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="adm-side-foot">
          {admin && (
            <div className="adm-user">
              <span className="adm-user-name">{admin.nome}</span>
              <span className="adm-user-email">{admin.email}</span>
            </div>
          )}
          <button className="adm-logout" onClick={handleLogout} type="button">
            <IconLogout />
            Sair
          </button>
        </div>
      </aside>
      <main className="adm-main">
        <Outlet />
      </main>
    </div>
  );
}
